export const updateAt = (setter, index, patch) =>
  setter((prev) => {
    const next = prev.slice();
    next[index] = { ...prev[index], ...patch };
    return next;
  });

export const onZoomChange = (setter, index, zoom) =>
  updateAt(setter, index, { zoom });
export const onCropChange = (setter, index, crop) =>
  updateAt(setter, index, { crop });
export const onCropComplete = (
  setter,
  index,
  croppedArea,
  croppedAreaPixels
) => {
  updateAt(setter, index, { croppedAreaPixels });
};
export const setImageFor = (setter, index, imageSrc) =>
  updateAt(setter, index, { imageSrc });
